"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _passthroughProps = _interopRequireDefault(require("../utils/propTypes/passthroughProps"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _UIButton = _interopRequireDefault(require("./UIButton"));

var Button = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "UIIconButton__Button",
  componentId: "sc-1xlf72y-0"
})(["&&&{padding-left:0;padding-right:0;text-align:center;text-overflow:clip;}&&{font-size:", ";width:", ";}"], function (_ref) {
  var size = _ref.size;
  if (size === 'xs') return '12px';
  if (size === 'sm') return '16px';
  return '18px';
}, function (_ref2) {
  var size = _ref2.size,
      use = _ref2.use;
  if (use === 'unstyled' || use.includes('link')) return 'auto';
  if (size === 'xs') return '26px';
  if (size === 'sm') return '32px';
  return '40px';
});

var UIIconButton = function UIIconButton(props) {
  var autoPlacement = props.autoPlacement,
      className = props.className,
      placement = props.placement,
      shape = props.shape,
      size = props.size,
      tooltip = props.tooltip,
      tooltipProps = props.tooltipProps,
      TooltipContent = props.TooltipContent,
      rest = (0, _objectWithoutProperties2.default)(props, ["autoPlacement", "className", "placement", "shape", "size", "tooltip", "tooltipProps", "TooltipContent"]);
  return _react.default.createElement(_UITooltip.default, Object.assign({
    autoPlacement: autoPlacement,
    Content: TooltipContent,
    title: tooltip,
    placement: placement
  }, tooltipProps), _react.default.createElement(Button, Object.assign({}, rest, {
    className: (0, _classnames.default)('private-button--icon-only', className, shape === 'circle' && 'private-button--circle'),
    responsive: false,
    size: (0, _tshirtSize.toShorthandSize)(size)
  })));
};

UIIconButton.propTypes = Object.assign({}, (0, _omit.default)(_UIButton.default.propTypes, ['block', 'responsive']), {
  autoPlacement: _UITooltip.default.propTypes.autoPlacement,
  children: _propTypes.default.node,
  iconClassName: _propTypes.default.string,
  placement: _UITooltip.default.propTypes.placement,
  shape: _propTypes.default.oneOf(['square', 'circle']),
  tooltip: _UITooltip.default.propTypes.title,
  tooltipProps: (0, _passthroughProps.default)(_UITooltip.default),
  TooltipContent: _UITooltip.default.propTypes.Content
});
UIIconButton.defaultProps = Object.assign({}, _UIButton.default.defaultProps, {
  block: false,
  placement: _UITooltip.default.defaultProps.placement,
  shape: 'square',
  use: 'tertiary-light'
});
UIIconButton.displayName = 'UIIconButton';
var _default = UIIconButton;
exports.default = _default;
module.exports = exports.default;